import {Link} from "react-router-dom";
import {css} from "@emotion/react";

import {backgroundColor, borderRadius, mt, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes/src/rp_app_link";

const creditCalculatorComponentsList: string[] = [
    "RRSO i oprocentowanie oparte o WIBOR lub WIRON,",
    "marża banku,",
    "odsetki,",
    "prowizje,",
    "ubezpieczenia,",
    "wymagany minimalny wkład własny."
];

const creditCalculatorLoanRequirements: string[] = [" podać całościową cenę nieruchomości,", " wpisać swój wkład własny,", " określić czas spłaty kredytu."];

export const CreditOfferInfoText = () => {
    return (
        <div css={boxWrapper}>
            <Text variant="headline_2" strong>
                Kalkulator kredytu hipotecznego, czyli symulacja rat Twojego przyszłego zobowiązania
            </Text>
            <Text variant="body_copy_2" strong css={mt(2)}>
                Kalkulator kredytu hipotecznego (zwany również kalkulatorem kredytowym, kalkulatorem rat lub kalkulatorem kredytu) pozwala na symulację rat
                zaciągniętego przez Ciebie zobowiązania na wymarzone M. Jest to kluczowe ze względu na Twój budżet domowy. Dzięki kalkulatorowi kredytu
                hipotecznego jeszcze przed podpisaniem umowy będziesz wiedzieć, w jakim stopniu miesięczna rata obciąży Twoje finanse.
            </Text>
            <Text variant="headline_3" strong css={mt(2)}>
                Co to jest kalkulator kredytu hipotecznego?
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Kalkulator kredytu hipotecznego to narzędzie pozwalające na szybką estymację wysokości i kosztów zobowiązania na zakup, remont lub budowę
                mieszkania, domu albo działki. Kalkulator kredytowy uwzględnia takie składowe oferty, jak:
            </Text>
            <ul>
                {creditCalculatorComponentsList.map((item, index) => (
                    <li key={index}>
                        <Text variant="body_copy_2">{item}</Text>
                    </li>
                ))}
            </ul>
            <Text variant="body_copy_2" css={mt(2)}>
                Istnieją także kalkulatory kredytu hipotecznego, które biorą pod uwagę także 2 typy rat:
            </Text>
            <ul>
                <li>
                    <Text variant="body_copy_2">
                        <span css={spanBold}>raty równe</span> – wówczas wszystkie raty kapitałowo–odsetkowe są stałe przez cały okres kredytowania
                    </Text>
                </li>
                <li>
                    <Text variant="body_copy_2">
                        <span css={spanBold}>raty malejące</span> – w tym wariancie raty będą maleć wraz ze spłatą kolejnych miesięcy.
                    </Text>
                </li>
            </ul>
            <Text variant="body_copy_2" css={mt(2)}>
                W niektórych przypadkach kalkulator rat generuje również <span css={spanBold}>harmonogram spłaty kredytu</span>, dzięki któremu dowiesz się, jak
                rozkłada się całkowity koszt kredytu w skali całego okresu obowiązywania umowy.{" "}
            </Text>
            <Text variant="headline_3" strong css={mt(2)}>
                Jak obliczysz ratę dzięki kalkulatorowi kredytu?
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Aby obliczyć ratę kredytu hipotecznego w naszym darmowym narzędziu w pierwszej kolejności musisz:
            </Text>
            <ol>
                {creditCalculatorLoanRequirements.map((item, index) => (
                    <li key={index}>
                        <Text variant="body_copy_2">{item}</Text>
                    </li>
                ))}
            </ol>
            <Text variant="body_copy_2" css={mt(2)}>
                Następnie kalkulator kredytowy wygeneruje najlepsze oferty banków m.in. mBank, PKO BP, Santander, Alior, Credit Agricole, BNP Paribas czy Pekao
                S.A. Nie musisz też samodzielnie obliczać swojej zdolności kredytowej – wystarczy skorzystać z funkcji &quot;Sprawdź zdolność kredytową&quot; i
                zapoznaj się ze szczegółowymi informacjami.
                <br />
                Zainteresowała Cię konkretna oferta, którą zaproponował Ci kalkulator kredytowy? Sprawdź szczegóły, klikając w &quot;Zapytaj o kredyt&quot; i
                poznaj możliwości, jakie proponuje konkretna hipoteka.
            </Text>
            <Text variant="headline_3" strong css={mt(2)}>
                Co musisz zrobić przed skorzystaniem z kalkulatora raty kredytu?
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Aby korzystać z kalkulatora raty zapoznaj się z najważniejszymi elementami ścieżki zakupu i finansowania wymarzonej nieruchomości. W pierwszej
                kolejności dowiedz się,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "kredyt-hipoteczny-czym-jest-i-jak-go-uzyskac", articleId: 10569})}>
                    czym tak naprawdę jest kredyt hipoteczny
                </Link>
                . Następnie określ budżet na zakup mieszkania oraz wysokość{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "wklad-wlasny-fakty-i-mity", articleId: 9313})}>
                    wkładu własnego
                </Link>
                .
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Następnie dowiedz się,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "zdolnosc-kredytowa-co-to", articleId: 12518})}>
                    czym właściwie jest zdolność kredytowa
                </Link>{" "}
                i{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "jak-zwiekszyc-zdolnosc-kredytowa", articleId: 663})}>
                    w jaki sposób możesz ją wzmocnić
                </Link>
                . Aby przygotować się do korzystania z kalkulatora rat,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "bik-a-kredyt-hipoteczny", articleId: 1632})}>
                    sprawdź również swój raport w BIK
                </Link>
                , aby uniknąć nieprzyjemnych niespodzianek przy estymacji swojej zdolności.
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Weź pod uwagę również swoją sytuację zawodową i sprawdź,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "umowa-o-dzielo-a-kredyt-mieszkaniowy", articleId: 11067})}>
                    jakie masz możliwości wzięcia kredytu również przy umowach cywilnoprawnych
                </Link>{" "}
                lub{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "kredyt-hipoteczny-przy-umowie-na-czas-okreslony", articleId: 12345})}>
                    przy umowie na czas określony
                </Link>
                .
            </Text>
            <Text variant="body_copy_2" css={mt(2)} strong>
                Jeśli znasz swoją sytuację, już teraz skorzystaj z kalkulatora rat kredytu hipotecznego i przygotuj się do złożenia wniosku! Dowiedz się, jakie
                możliwości skrywa kalkulator kredytowy i jak może Ci pomóc w drodze po wymarzone M.
            </Text>
            <Text variant="body_copy_2" css={mt(2)} strong>
                Znajdziesz tutaj odpowiedzi na najczęściej zadawane pytania oraz wskazówki, jak skutecznie ubiegać się o kredyt hipoteczny.
            </Text>
        </div>
    );
};

const boxWrapper = css`
    ${mt(5)};
    ${backgroundColor("#FFF")};
    ${p(3)};
    ${borderRadius(1)};
`;

const linkUnderline = css`
    text-decoration: underline;
`;

const spanBold = css`
    font-weight: bold;
`;
import {Link} from "react-router-dom";
import {css} from "@emotion/react";

import {backgroundColor, borderRadius, mt, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes/src/rp_app_link";

const creditCalculatorComponentsList: string[] = [
    "RRSO i oprocentowanie oparte o WIBOR lub WIRON,",
    "marża banku,",
    "odsetki,",
    "prowizje,",
    "ubezpieczenia,",
    "wymagany minimalny wkład własny."
];

const creditCalculatorLoanRequirements: string[] = [" podać całościową cenę nieruchomości,", " wpisać swój wkład własny,", " określić czas spłaty kredytu."];

export const CreditOfferInfoText = () => {
    return (
        <div css={boxWrapper}>
            <Text variant="headline_2" strong>
                Kalkulator kredytu hipotecznego, czyli symulacja rat Twojego przyszłego zobowiązania
            </Text>
            <Text variant="body_copy_2" strong css={mt(2)}>
                Kalkulator kredytu hipotecznego (zwany również kalkulatorem kredytowym, kalkulatorem rat lub kalkulatorem kredytu) pozwala na symulację rat
                zaciągniętego przez Ciebie zobowiązania na wymarzone M. Jest to kluczowe ze względu na Twój budżet domowy. Dzięki kalkulatorowi kredytu
                hipotecznego jeszcze przed podpisaniem umowy będziesz wiedzieć, w jakim stopniu miesięczna rata obciąży Twoje finanse.
            </Text>
            <Text variant="headline_3" strong css={mt(2)}>
                Co to jest kalkulator kredytu hipotecznego?
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Kalkulator kredytu hipotecznego to narzędzie pozwalające na szybką estymację wysokości i kosztów zobowiązania na zakup, remont lub budowę
                mieszkania, domu albo działki. Kalkulator kredytowy uwzględnia takie składowe oferty, jak:
            </Text>
            <ul>
                {creditCalculatorComponentsList.map((item, index) => (
                    <li key={index}>
                        <Text variant="body_copy_2">{item}</Text>
                    </li>
                ))}
            </ul>
            <Text variant="body_copy_2" css={mt(2)}>
                Istnieją także kalkulatory kredytu hipotecznego, które biorą pod uwagę także 2 typy rat:
            </Text>
            <ul>
                <li>
                    <Text variant="body_copy_2">
                        <span css={spanBold}>raty równe</span> – wówczas wszystkie raty kapitałowo–odsetkowe są stałe przez cały okres kredytowania
                    </Text>
                </li>
                <li>
                    <Text variant="body_copy_2">
                        <span css={spanBold}>raty malejące</span> – w tym wariancie raty będą maleć wraz ze spłatą kolejnych miesięcy.
                    </Text>
                </li>
            </ul>
            <Text variant="body_copy_2" css={mt(2)}>
                W niektórych przypadkach kalkulator rat generuje również <span css={spanBold}>harmonogram spłaty kredytu</span>, dzięki któremu dowiesz się, jak
                rozkłada się całkowity koszt kredytu w skali całego okresu obowiązywania umowy.{" "}
            </Text>
            <Text variant="headline_3" strong css={mt(2)}>
                Jak obliczysz ratę dzięki kalkulatorowi kredytu?
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Aby obliczyć ratę kredytu hipotecznego w naszym darmowym narzędziu w pierwszej kolejności musisz:
            </Text>
            <ol>
                {creditCalculatorLoanRequirements.map((item, index) => (
                    <li key={index}>
                        <Text variant="body_copy_2">{item}</Text>
                    </li>
                ))}
            </ol>
            <Text variant="body_copy_2" css={mt(2)}>
                Następnie kalkulator kredytowy wygeneruje najlepsze oferty banków m.in. mBank, PKO BP, Santander, Alior, Credit Agricole, BNP Paribas czy Pekao
                S.A. Nie musisz też samodzielnie obliczać swojej zdolności kredytowej – wystarczy skorzystać z funkcji &quot;Sprawdź zdolność kredytową&quot; i
                zapoznaj się ze szczegółowymi informacjami.
                <br />
                Zainteresowała Cię konkretna oferta, którą zaproponował Ci kalkulator kredytowy? Sprawdź szczegóły, klikając w &quot;Zapytaj o kredyt&quot; i
                poznaj możliwości, jakie proponuje konkretna hipoteka.
            </Text>
            <Text variant="headline_3" strong css={mt(2)}>
                Co musisz zrobić przed skorzystaniem z kalkulatora raty kredytu?
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Aby korzystać z kalkulatora raty zapoznaj się z najważniejszymi elementami ścieżki zakupu i finansowania wymarzonej nieruchomości. W pierwszej
                kolejności dowiedz się,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "kredyt-hipoteczny-czym-jest-i-jak-go-uzyskac", articleId: 10569})}>
                    czym tak naprawdę jest kredyt hipoteczny
                </Link>
                . Następnie określ budżet na zakup mieszkania oraz wysokość{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "wklad-wlasny-fakty-i-mity", articleId: 9313})}>
                    wkładu własnego
                </Link>
                .
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Następnie dowiedz się,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "zdolnosc-kredytowa-co-to", articleId: 12518})}>
                    czym właściwie jest zdolność kredytowa
                </Link>{" "}
                i{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "jak-zwiekszyc-zdolnosc-kredytowa", articleId: 663})}>
                    w jaki sposób możesz ją wzmocnić
                </Link>
                . Aby przygotować się do korzystania z kalkulatora rat,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "bik-a-kredyt-hipoteczny", articleId: 1632})}>
                    sprawdź również swój raport w BIK
                </Link>
                , aby uniknąć nieprzyjemnych niespodzianek przy estymacji swojej zdolności.
            </Text>
            <Text variant="body_copy_2" css={mt(2)}>
                Weź pod uwagę również swoją sytuację zawodową i sprawdź,{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "umowa-o-dzielo-a-kredyt-mieszkaniowy", articleId: 11067})}>
                    jakie masz możliwości wzięcia kredytu również przy umowach cywilnoprawnych
                </Link>{" "}
                lub{" "}
                <Link css={linkUnderline} to={rpAppLink.article.detail({articleSlug: "kredyt-hipoteczny-przy-umowie-na-czas-okreslony", articleId: 12345})}>
                    przy umowie na czas określony
                </Link>
                .
            </Text>
            <Text variant="body_copy_2" css={mt(2)} strong>
                Jeśli znasz swoją sytuację, już teraz skorzystaj z kalkulatora rat kredytu hipotecznego i przygotuj się do złożenia wniosku! Dowiedz się, jakie
                możliwości skrywa kalkulator kredytowy i jak może Ci pomóc w drodze po wymarzone M.
            </Text>
            <Text variant="body_copy_2" css={mt(2)} strong>
                Znajdziesz tutaj odpowiedzi na najczęściej zadawane pytania oraz wskazówki, jak skutecznie ubiegać się o kredyt hipoteczny.
            </Text>
        </div>
    );
};

const boxWrapper = css`
    ${mt(5)};
    ${backgroundColor("#FFF")};
    ${p(3)};
    ${borderRadius(1)};
`;

const linkUnderline = css`
    text-decoration: underline;
`;

const spanBold = css`
    font-weight: bold;
`;
